/* Форматирование значений KPI по единице из каталога показателей (kpi.py):
   rub — рубли, percent — доля (0.27 = 27%), count — штуки, min — минуты,
   points — оценка 1–10. Проценты хранятся долей, а вводятся и показываются
   в процентах — как в Excel управляющего. */

export const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
export const MONTHS_GEN = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
export const MONTHS_SHORT = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

const num = (v, digits = 0) => new Intl.NumberFormat('ru-RU', { maximumFractionDigits: digits }).format(v);

export const money = (v) => `${num(Math.round(v || 0))} ₽`;

export const fmtValue = (unit, v) => {
  if (v === null || v === undefined || v === '') return '—';
  switch (unit) {
    case 'rub': return money(v);
    case 'percent': return `${num(v * 100, 1)}%`;
    case 'min': return `${num(v, 1)} мин`;
    case 'points': return `${num(v, 1)} из 10`;
    default: return num(v, 1);
  }
};

export const unitSuffix = (unit) => ({ rub: '₽', percent: '%', min: 'мин', points: 'балл' }[unit] || 'шт.');

/* Значение для поля ввода и обратно. */
export const toInput = (unit, v) => {
  if (v === null || v === undefined) return '';
  return unit === 'percent' ? String(+(v * 100).toFixed(2)) : String(v);
};

export const fromInput = (unit, s) => {
  const clean = String(s).replace(/\s/g, '').replace(',', '.');
  if (clean === '') return null;
  const n = Number(clean);
  if (!Number.isFinite(n)) return undefined;
  return unit === 'percent' ? n / 100 : n;
};

export const fmtScore = (s) => (s === null || s === undefined ? '—' : num(s, 2));

export const scoreTone = (s) => {
  if (s === null || s === undefined) return 'none';
  if (s >= 9) return 'top';
  if (s >= 7) return 'ok';
  if (s >= 5) return 'mid';
  return 'low';
};

export const bonusText = (bonus, amount) => (bonus?.kind === 'percent'
  ? `${num(amount * 100, 2)}% от выручки`
  : money(amount));

export const periodLabel = (year, month) => `${MONTHS[month - 1]} ${year}`;
